import React from 'react';
import "./header-footer.css"
import logo1 from "../assets/logo1.png"
function Header({ onStart, action }) {

  return (
    <header className="header">
      <img src={logo1} alt='log' width={100}/>
      <button className="start-btn" onClick={onStart}>{action}</button>
    </header>
  );
}

export default Header;
